const time = {
  "周": "minggu",
  "天": "hari",
  "小时": "jam",
  "分钟": "menit",
  "刚刚": "Baru saja",
  "前": " yang lalu",

  "昨天": "Kemarin",
  "星期一": "Senin",
  "星期二": "Selasa",
  "星期三": "Rabu",
  "星期四": "Kamis",
  "星期五": "Jumat",
  "星期六": "Sabtu",
  "星期日": "Minggu",
}

export default time;